import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import {
  showCreateAccount,
  showRequestResetPassword,
  submitLogInForm,
} from '../../user';
import { Login } from '../Login';

const mapDispatchToProps = (dispatch, ownProps) => {
  const { loginCallback, shouldRedirectToDashboard } = ownProps;
  return {
    onSubmit: data =>
      dispatch(submitLogInForm(data, loginCallback, shouldRedirectToDashboard)),
    clickCreateAccount: () => dispatch(showCreateAccount('Create Account')),
    clickRequestResetPassword: () =>
      dispatch(showRequestResetPassword('Forgot Password')),
  };
};

const mapStateToProps = ({}, { feedUrl, signupUrl }) => ({
  feedUrl,
  signupUrl,
});

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
  })(Login)
);

export { LoginContainer };
